function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".err-ic_svg__st0{fill:none;stroke:#f54865;stroke-width:1.5}");

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "err-ic_svg__Oval-6-Copy",
  className: "err-ic_svg__st0",
  cx: 12,
  cy: 12,
  r: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "err-ic_svg__st0",
  d: "M15.2 8.8l-6.4 6.4M8.8 8.8l6.4 6.4"
});

function SvgErrIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "err-ic_svg__Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "644f84a5c939127ef40201115aa1c323.svg";
export { SvgErrIc as ReactComponent };